// extracted by mini-css-extract-plugin
module.exports = {"editor":"index_editor_oFNfd","ql-toolbar":"index_ql-toolbar_2xMDr","ql-container":"index_ql-container_2aXqt"};